<template>
  <div class="py-5 md:px-5">
    <PageHeader class="container" title="Vendors">
      <button class="btn btn-primary" @click="newVendor">
        Add Vendor
      </button>
    </PageHeader>

    <Modal :open.sync="showVendorForm" :title="mode.title">
      <div class="p-6">
        <form @submit.prevent="mode.function" class="space-y-4">
          <fieldset>
            <label for="name" class="form-label">Name</label>
            <input id="name" type="text" class="form-input" v-model="form.name">
          </fieldset>
          <div class="flex items-center justify-between">
            <button class="btn btn-primary" v-submitting="submitting">
              {{ mode.action }}
            </button>
            <!-- <button class="text-red-500" v-if="mode.title === 'Edit Vendor'" @click="removeVendor()" v-submitting="submitting">
              Remove
            </button> -->
          </div>
        </form>
      </div>
    </Modal>

    <div class="container">
      <Loading v-if="loading" />

      <div class="card" v-else>
        <!-- No Results -->
        <div v-if="vendors.meta.total < 1" class="py-12 text-center">
          <p class="mb-8 text-lg font-bold">
            This account doesn't have any vendors.
          </p>
          <button class="btn btn-secondary" @click="newVendor">
            Add Vendor
          </button>
        </div>

        <!-- Results -->
        <div v-else>
          <!-- Table -->
          <data-table 
            :items="vendors.data" 
            :keys="[
              { name: 'Name', slug: 'name', class: 'font-bold' }
            ]">
            <template #actions="{ item }">
              <button class="btn btn-sm btn-secondary" @click="editVendor(item)">
                Edit
              </button>
            </template>
          </data-table>
          <!-- Pagination -->
          <Pagination class="rounded-b-lg" :total="vendors.meta.total" :per-page="vendors.meta.per_page" :current-page="vendors.meta.current_page" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'VendorList',

  metaInfo: {
    title: 'Vendors'
  },

  created () {
    this.getVendors()
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      loading: true,
      submitting: false,
      showVendorForm: false,
      mode: {
        title: 'Add Vendor',
        function: this.createVendor,
        action: 'Add Vendor'
      },
      form: {
        name: ''
      },
      vendors: []
    }
  },

  methods: {
    newVendor () {
      this.mode = {
        title: 'Add Vendor',
        function: this.createVendor,
        action: 'Add Vendor'
      }
      this.form = {
        name: ''
      }
      this.showVendorForm = true
    },

    editVendor (vendor) {
      this.mode = {
        title: 'Edit Vendor',
        function: this.updateVendor,
        action: 'Save Changes'
      }
      this.form = JSON.parse(JSON.stringify(vendor))
      this.showVendorForm = true
    },

    async getVendors () {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/vendors`)
        this.vendors = data.vendors
        this.loading = false
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      }
    },

    async createVendor () {
      try {
        this.submitting = true
        await this.$api.post(`account/${this.$route.params.account}/vendors`, this.form)
        this.showVendorForm = false
        this.form = {
          name: ''
        }
        this.getVendors()
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.submitting = false
      }
    },

    async updateVendor () {
      try {
        this.submitting = true
        await this.$api.patch(`account/${this.$route.params.account}/vendors/${this.form.id}`, this.form)
        this.showVendorForm = false
        this.form = {
          name: ''
        }
        this.getVendors()
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.submitting = false
      }
    },

    // async removeVendor (vendor) {
    //   if (window.confirm('Are you sure you want to remove this vendor from your account?')) {
    //     try {
    //       this.submitting = true
    //       await this.$api.delete(`account/${this.$route.params.account}/vendors/${this.form.id}`)
    //       this.getVendors()
    //     } catch (error) {
    //       console.error(error)
    //     } finally {
    //       this.submitting = false
    //     }
    //   }
    // }
  }
}
</script>